import { render, staticRenderFns } from "./lk-tablet-menu.vue?vue&type=template&id=ca86ba1c&"
import script from "./lk-tablet-menu.vue?vue&type=script&lang=js&"
export * from "./lk-tablet-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-tablet-menu/lk-tablet-menu.vue
// module id = 1310
// module chunks = 0